export default __webpack_public_path__ + "static/pau-960ccdf2c2443790688463cd83df7206.png";